import { RemotePrintersList } from './RemotePrintersList'

export default RemotePrintersList
